import React, { Component, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { useHistory } from "react-router-dom";
import { Slide } from 'react-slideshow-image';
import { fetchDefault } from './Utils.js';

const useStyles = makeStyles(theme => ({
    fullImage: {
        //position: 'fixed',
        marginTop: 8,
    },
    lineSpacing: {
        marginTop: 30,
        marginBottom: 30,
    },
    buttonSpace: {
        margin: theme.spacing(0.5),
        fontSize: 20
    },
}));

export default function DisplayNotice(props) {
    const classes = useStyles();
    let history = useHistory();

    useEffect(() => {
        return () => {
        }

    }, []);

    return (
        <div>

            <Typography variant="h4" className={classes.lineSpacing}>스터디카페에서 안내드립니다.</Typography>
            <Typography variant="h6" className={classes.lineSpacing}>{props.match.params.message == "1" ? '현재 이용하고 계신 자리는 예약이 안되신 자리로 감지되었습니다.' : props.match.params.message}</Typography>
            <Typography variant="h6" className={classes.lineSpacing}>아래 전화번호로 관리자에게 연락 바랍니다.</Typography>
            <Typography variant="h6" className={classes.lineSpacing}><a href="tel:010-3849-0843">010-3849-0843</a></Typography>
            
        </div>
    );
    
}



// WEBPACK FOOTER //
// ./src/components/DisplayNotice.js